import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { handleRequestWithBody } from "@utils/http-util";
import { GenericNetworkResponse } from "@idw-types/generic-network-response";
import { ServiceTemplateDetails } from "@idw-types/data/service-template-details/service-template-details";
import { EntityStatusTypes } from "@enums/entity-status-types";

type CreateServiceTemplateRequestResponse = {
    response: ServiceTemplateDetails;
};

export const createServiceTemplateRequest = async (
    serviceTemplate: Partial<ServiceTemplateDetails>
): Promise<GenericNetworkResponse<CreateServiceTemplateRequestResponse>> => {
    const route = apiRoutes.serviceConfiguration.data.serviceTemplate;

    const body: Partial<ServiceTemplateDetails> = {
        id: null,
        description: serviceTemplate.description,
        name: serviceTemplate.name,
        ssoTemplate: serviceTemplate.ssoTemplate,
        status: EntityStatusTypes.ACTIVE,
        organizationID: serviceTemplate.organizationID
    };

    const { data, error } = await handleRequestWithBody(RequestTypes.POST, route, body);
    return { data, error, body };
};